import {FormProps} from "@/types/form/FormProps";

export enum RSFORM_MUTATION {
  UPDATE_RSFORM = "UPDATE_RSFORM",
  CLEAR = "CLEAR",
}

export enum RSFORM_ACTION {
  UPDATE_RSFORM = "rsForm/UPDATE_RSFORM",
  CLEAR = "rsForm/CLEAR",
}

export interface RSForm {
  form: FormProps;
}

export interface RSFormMutations {
  UPDATE_RSFORM(form: FormProps): void;
  CLEAR(): void;
}

export interface RSFormActions {
  UPDATE_RSFORM(form: FormProps): void;
  CLEAR(): void;
}
